export default import.meta.ROLLDOWN_FILE_URL_oyKCALxAIw6qJYMqiP_KZg